export * from './serviceContent.service';
import { ServiceContentService } from './serviceContent.service';
export * from './servicePartner.service';
import { ServicePartnerService } from './servicePartner.service';
export * from './servicePlan.service';
import { ServicePlanService } from './servicePlan.service';
export * from './vasService.service';
import { VasServiceService } from './vasService.service';
export * from './vasServiceNetwork.service';
import { VasServiceNetworkService } from './vasServiceNetwork.service';
export * from './vasServiceResponse.service';
import { VasServiceResponseService } from './vasServiceResponse.service';
export * from './vasServiceRevenue.service';
import { VasServiceRevenueService } from './vasServiceRevenue.service';
export * from './vasServiceRoute.service';
import { VasServiceRouteService } from './vasServiceRoute.service';
export const APIS = [ServiceContentService, ServicePartnerService, ServicePlanService, VasServiceService, VasServiceNetworkService, VasServiceResponseService, VasServiceRevenueService, VasServiceRouteService];
